import { HashRouter as Router, Routes, Route, Link, Navigate, useParams, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import ComicReader from './components/ComicReader';
import Games from './pages/Games';
import About from './pages/About';
import Admin from './pages/admin';
import Collection from './pages/Collection';
import Gallery from './pages/Gallery';
import { AuthProvider } from './content/Auth';
import { CatalogProvider, CatalogNotice } from './content/Catalog';
import './styles.css';
import './studio.css';

export function LegacyEssayRedirect() {
  const { id } = useParams();
  const { search } = useLocation();
  return <Navigate replace to={`${id ? `/blog/essays/${encodeURIComponent(id)}` : '/blog'}${search}`} />;
}

export default function App() {
  return <AuthProvider><CatalogProvider><Router><a className="skip-link" href="#main-content" onClick={(event) => { event.preventDefault(); document.getElementById('main-content')?.focus(); document.getElementById('main-content')?.scrollIntoView(); }}>Skip to content</a><Header /><Navbar /><div id="main-content" tabIndex={-1}><CatalogNotice /><Routes>
    <Route path="/" element={<Hero />} />
    <Route path="/comics" element={<Collection key="comics" type="comics" />} />
    <Route path="/comics/:id" element={<ComicReader />} />
    <Route path="/animations" element={<Collection key="animations" type="animations" />} />
    <Route path="/animations/:id" element={<Collection type="animations" />} />
    <Route path="/portfolio" element={<Gallery />} />
    <Route path="/portfolio/:id" element={<Gallery />} />
    <Route path="/art/:id" element={<Collection type="artwork" />} />
    {['blog', 'stories'].map((type) => <Route key={type} path={`/${type}`} element={<Collection key={type} type={type} />} />)}
    {['blog', 'stories'].map((type) => <Route key={`${type}-detail`} path={`/${type}/:id`} element={<Collection type={type} />} />)}
    <Route path="/blog/essays/:id" element={<Collection type="blog" recordType="essays" />} />
    <Route path="/essays" element={<LegacyEssayRedirect />} />
    <Route path="/essays/:id" element={<LegacyEssayRedirect />} />
    <Route path="/games" element={<Games />} />
    <Route path="/games/:gameId" element={<Games />} />
    <Route path="/about" element={<About />} />
    <Route path="/admin" element={<Admin />} />
    <Route path="*" element={<main className="page-shell"><h1>This trail went sideways.</h1><Link to="/">Head home</Link></main>} />
  </Routes></div><Footer /></Router></CatalogProvider></AuthProvider>;
}
